module.exports = __webpack_public_path__ + "static/media/sb.69f5bc89.svg";